import { render, staticRenderFns } from "./customer-dashboard.vue?vue&type=template&id=579e8a48&scoped=true"
import script from "./customer-dashboard.vue?vue&type=script&lang=js"
export * from "./customer-dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/user.css?vue&type=style&index=0&id=579e8a48&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579e8a48",
  null
  
)

export default component.exports